exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-7ac90e12], .fade-leave-active[data-v-7ac90e12] {\n    -webkit-transition: 0.5s;\n    transition: 0.5s;\n}\n.fade-enter[data-v-7ac90e12], .fade-leave-to[data-v-7ac90e12] {\n    opacity: 0;\n}\n.fade-enter .Modal__wrapper[data-v-7ac90e12], .fade-leave-to .Modal__wrapper[data-v-7ac90e12] {\n    -webkit-transform: translateY(-20%);\n            transform: translateY(-20%);\n}\n.Modal__wrapper[data-v-7ac90e12] {\n    -webkit-transition: 0.5s;\n    transition: 0.5s;\n}\n", ""]);

// exports
